import React from 'react';

const PhoneIcon = () => {
  return (
    <svg className='iconTop' width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M67.787 24A39.963 39.963 0 0 1 96 52.213M65.656 37.406a23.978 23.978 0 0 1 16.928 16.928" stroke="var(--theme-primary, #810ea9)" strokeWidth="4.4" strokeLinecap="round" strokeLinejoin="round" />
      <path clipRule="evenodd" d="M43.713 60.27a34.9 34.9 0 0 0 16.16 16.086 3.28 3.28 0 0 0 3.239-.245l10.358-6.907a3.31 3.31 0 0 1 3.14-.289l19.38 8.306a3.3 3.3 0 0 1 1.986 3.432C96.709 90.57 88.27 98 78.273 98 47.194 98 22 72.806 22 41.727c0-9.997 7.43-18.436 17.346-19.703a3.3 3.3 0 0 1 3.433 1.985l8.313 19.397a3.31 3.31 0 0 1-.273 3.117L43.936 57.04a3.28 3.28 0 0 0-.223 3.23z" stroke="#000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

  );
};

export default PhoneIcon;
